import { QarepaEnumInformation } from '@qarepa/common';

export enum CalendarStatusEnum {
  PENDING = 'PENDING',
  CLOSE = 'CLOSE',
}

export type CalendarStatusType =
  CalendarStatusEnum.PENDING | CalendarStatusEnum.CLOSE;

export const CalendarStatusArray = [
  CalendarStatusEnum.PENDING,
  CalendarStatusEnum.CLOSE,
];

export const CalendarStatusInfo: QarepaEnumInformation<CalendarStatusEnum> = {
  [CalendarStatusEnum.PENDING]: {
    name: $localize`Pendiente`,
  },
  [CalendarStatusEnum.CLOSE]: {
    name: $localize`Cerrado`,
  },
};
